/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_D4dInputs */

const en_mk_sol_operasional_d4d = /** @type {(inputs: Mk_Sol_Operasional_D4dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who approved, when, and on what basis is stored in one exportable place.`)
};

const id_mk_sol_operasional_d4d = /** @type {(inputs: Mk_Sol_Operasional_D4dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siapa menyetujui, kapan, dan atas dasar apa tersimpan di satu tempat yang bisa diekspor.`)
};

/**
* | output |
* | --- |
* | "Who approved, when, and on what basis is stored in one exportable place." |
*
* @param {Mk_Sol_Operasional_D4dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_d4d = /** @type {((inputs?: Mk_Sol_Operasional_D4dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_D4dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_d4d(inputs)
	return en_mk_sol_operasional_d4d(inputs)
});